import { RootState } from "../store";
import { getTranslate } from "react-localize-redux";


export const mapStateToPropsLocalize = (state: RootState) => ({
    translateFunc: getTranslate(state.localize)
});